<template>
  <div class="d-flex align-items-center min-vh-100">
    <CContainer>
      <div class="col-12 p-0">
        <CCard class="col-4 tablet-bg-8 mx-auto card--custom animate__animated animate__fadeIn">
          <CCardBody>
            <div class="card-header mb-4 pb-0">
              <h5 class="text-center mb-4">Registro de desarrolladores infonavit</h5>
            </div>
            <form @submit="handleSubmit">
              <div class="form-group relative group--custom">
                <input
                  type="text"
                  class="form-control input--custom"
                  placeholder="RFC"
                  @keyup="handleRFC"
                />
              </div>
              <div class="form-group relative group--custom">
                <input
                  type="email"
                  class="form-control input--custom"
                  placeholder="e-mail"
                  @keyup="handleEmail"
                />
              </div>
              <div class="form-group relative group--custom">
                <input
                  type="password"
                  name="pass1"
                  class="form-control input--custom"
                  placeholder="Contraseña"
                  @keyup="handlePass"
                />
              </div>
              <div class="form-group relative group--custom">
                <input
                  type="password"
                  name="pass2"
                  class="form-control input--custom"
                  placeholder="Repite tu contraseña"
                  @keyup="handlePass"
                />
              </div>
              <div
                class="form-group checkbox__group d-flex align-items-start mt-3"
              >
                <input id="terms" type="checkbox" class="" />
                <label for="tems" class="d-block ml-1"
                  >Acepto <a href="">Términos y condiciones</a> y
                  <a href="">Aviso de privacidad</a>
                </label>
              </div>
              <div class="form-group mt-4 d-flex">
                <button type="submit" class="btn btn-primary--custom flex-grow-1"
                  >Registrarme</button
                >
              </div>
              <div class="card-footer text-center">
                <div>
                  <p class="mt-3 mb-0">¿Ya tienes cuenta?</p>
                  <router-link
                    to="../login"
                    class="text-primary--custom text-underline"
                    >Ingresa</router-link
                  >
                </div>
              </div>
            </form>
          </CCardBody>
        </CCard>
      </div>
    </CContainer>
  </div>
</template>

<script>

import { validate } from '../../assets/helpers'

export default {
  name: "Register",
  data() {
      return {
          rfc: {},
          email: {},
          pass: {}
      }
  },

  methods: {
    register() {
      this.$router.push({ path: "/dashboard" });
    },

    handleRFC(e) {
        this.rfc.value = e.target.value.replaceAll(" ", "");
        if (this.rfc.value.length === 13 || this.rfc.value.length === 12) {
            this.rfc.validated = true
        } else this.rfc.validated = false;
    },

    handleEmail(e) {
        const isValid = validate.email(e.target.value);
        if (isValid) {
            this.email.value = e.target.value;
            this.email.validated = true;
        } else this.email.validated = false;
    },

    handlePass(e) {
        this.pass[e.target.name] = e.target.value;
        const { pass1, pass2 } = this.pass;

        if (pass1 === pass2) {
            if (validate.password(pass1)) {
                this.pass.validated = true;
            } else {
                this.pass.validated = false;
            }
        }
    },

    handleSubmit(e) {
        e.preventDefault();

        if (!this.rfc.validated || !this.email.validated || !this.pass.validated) {
            alert("Por favor corrige los campos")
            return;
        }

        const payload = {
            metodo: "",
            data: {
                RFC: this.rfc.value,
                email: this.email.value,
                pass: this.pass.pass1
            }
        };

        console.log(payload);
    }

  },
};
</script>
